import {FunnelsQuery} from 'common/report/models/funnels/funnels-query';
import {DateKeyedFunnelSegments} from 'common/report/models/funnels/types';
import {OverviewPanelAttrs} from 'common/report/widgets/funnels/overview-panel/index';
import {
  getHighestConversionRateFromSegments,
  getOverallConversionRateFromSegments,
  hasData,
} from 'common/report/util/funnels/utils';

export function overviewPanelAttrsFromFunnelsQuery(
  query: FunnelsQuery,
  segmentData: DateKeyedFunnelSegments[],
  comparisonSegmentData: DateKeyedFunnelSegments[],
): OverviewPanelAttrs {
  return {
    conversion: query.isGroupedSteps()
      ? getHighestConversionRateFromSegments(segmentData)
      : getOverallConversionRateFromSegments(segmentData),
    'conversion-label': query.isGroupedSteps() ? `Highest Conversion` : `Overall Conversion`,
    'conversion-window': query.conversionWindow,
    'count-type': query.countType,
    'funnel-order': query.funnelOrder,
    ...(hasData(comparisonSegmentData)
      ? {
          'past-conversion': query.isGroupedSteps()
            ? getHighestConversionRateFromSegments(comparisonSegmentData)
            : getOverallConversionRateFromSegments(comparisonSegmentData),
        }
      : {}),
  };
}
